import React, { useEffect, useState } from "react";
import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, IconButton, Tooltip, Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography, TablePagination, TextField,} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from '@mui/icons-material/Edit';
import AdminToolbar from "../../Toolbar/AdminToolbar";
import axios from "axios";
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import {  Tabs, Tab } from '@mui/material';
import { useNavigate } from "react-router-dom";
import PendingPost from "./PendingPost";
import ActivePost from "./ActivePost";
import YearImportantEvents from "./yearImportant";
import ExpiredPost from "./expiredPost";


const PostStatus = () => {
  const [pendingEvents, setPendingEvents] = useState([]);
  const [selected, setSelected] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => { 
  const fetchPendingEvents = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/pendingevents`);
      setPendingEvents(response.data);
    } catch (error) {
      console.error("Error fetching pending events:", error);
    }
  };

  fetchPendingEvents();
}, []);
const [isLoggedIn, setIsLoggedIn] = useState(false);
   const [userType, setUserType] = useState('');
   const [userName, setUsername] = useState('');
  const navigate = useNavigate();

  async function getUsernamefromCookie() {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/isLoggedIn`, { withCredentials: true }); 
      if (response.data.username ) {
        setUsername(response.data.username);
        setIsLoggedIn(true);
        setUserType(response.data.user);
      } else {
        setIsLoggedIn(false);
        navigate('/login'); 
      }
    } catch (error) {
      console.error('Error fetching login status:', error);
      navigate('/login'); 
    }
  }

  useEffect(() => {
    getUsernamefromCookie();
  }, []);

  const handleSelectAllClick = (event) => {
    setSelected(event.target.checked ? pendingEvents.map((event) => event._id) : []);
  };

  const handleRowClick = (id) => {
    setSelected((prevSelected) =>
      prevSelected.includes(id) ? prevSelected.filter((item) => item !== id) : [...prevSelected, id]
    );
  };

 const handleApprove = async (id) => {
  try {
    await axios.put(`${API_BASE_URL}/api/approveevent/${id}`, {
      approvedBy: "Admin",
      approvedBy:userName
    }, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== id));
  } catch (error) {
    console.error("Error approving event:", error);
  }
};

const handleReject = async (id) => {
  try {
    await axios.put(`${API_BASE_URL}/api/rejectevent/${id}`, {}, {
      headers: {
        "Content-Type": "application/json"
      }
    });

    setPendingEvents((prev) => prev.filter((event) => event._id !== id));
  } catch (error) {
    console.error("Error rejecting event:", error);
  }
};


  const handleOpenDialog = (event) => {
    setSelectedEvent(event);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedEvent(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedEvent((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
  `${API_BASE_URL}/api/approveevent/${selectedEvent._id}`,
  selectedEvent,
  {
    headers: {
      "Content-Type": "application/json"
    }
  }
);

      if (response.ok) {
        setPendingEvents((prev) =>
          prev.map((event) => (event._id === selectedEvent._id ? selectedEvent : event))
        );
        handleCloseDialog();
      } else {
        console.error("Error updating event:", await response.json());
      }
    } catch (error) {
      console.error("Error updating event:", error);
    }
  };

  return (
      <Box sx={{ width: '100%', padding: 0, margin: 0 }}>
      {
      isLoggedIn && 
      userName.length>0 ? (
        <>
        <AdminToolbar/>
        <div className="form-container-1">
        <Box sx={{ width: '100%', borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleTabChange} aria-label="permission tabs" >
          <Tab label="Pending Posts"/>
          <Tab label="Approved Posts"/>
          <Tab label="Yearly Recurring Posts "/>
          <Tab label="Expired Posts "/>
        </Tabs>
        {value === 0 && <PendingPost />} 
        {value === 1 && <ActivePost />} 
        {value === 2 && <YearImportantEvents />} 
        {value === 3 && <ExpiredPost />} 


        {/* {value === 1 && <PendingPermissions />} 
        {value === 2 && <RevokedPermissions />}  */}
      </Box>
      </div>
        </>
        ) : (
          <h4></h4>
        )}
      </Box>
  );
};

export default PostStatus;
